import React from "react";

const Loader = () => {
  return (
    <div className="center-align-container">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;